import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Align from '@marvelapp/marvel-ui/align';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';

import iconStyles from './style/icon.module.css';
import backgroundStyles from './style/background.module.css';

const cx = classNames.bind({ ...backgroundStyles, ...iconStyles });

const bgValues = [
  'marvel',
  'green',
  'teal',
  'yellow',
  'orange',
  'pink',
  'purple',
  'red',
];

export default function Feature({
  align,
  alignM,
  backgroundColor,
  copy,
  copyColor,
  fontWeight,
  headingColor,
  icon,
  maxImageWidth,
  maxWidth,
  src,
  tag,
  title,
}) {
  const iconClassName = cx('icon', backgroundColor);
  const Icon = icon;
  const iconProps = {
    className: iconClassName,
    style: {
      width: '40px',
      height: '40px',
    },
  };

  return (
    <Align type={align} typeM={alignM}>
      {icon && (
        <div className="display-inlineBlock">
          <div {...iconProps}>
            <Icon />
          </div>
        </div>
      )}
      {src && (
        <Spacing type="margin" size="l" position="topBottom">
          <Image
            alt={title}
            maxWidth={maxImageWidth || maxWidth}
            src={src}
            hasShadow={false}
          />
        </Spacing>
      )}
      <MaxWidth value={maxWidth || '100%'}>
        <Spacing type="margin" size="s" position="topBottom">
          <Spacing type="margin" size="xs" position="bottom">
            <Heading
              tag={tag}
              size="xl"
              color={headingColor}
              weight={fontWeight}
            >
              {title}
            </Heading>
          </Spacing>
          <Paragraph color={copyColor} size="m">
            {copy}
          </Paragraph>
        </Spacing>
      </MaxWidth>
    </Align>
  );
}

const validColors = [
  'white',
  'black',
  'steel',
  'slate',
  'silver',
  'darkSmoke',
  'extraDarkSmoke',
  'smoke',
  'darkSnow',
  'extraDarkSnow',
  'snow',
];

Feature.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  alignM: PropTypes.oneOf(['left', 'center', 'right']),
  backgroundColor: PropTypes.oneOf(bgValues),
  copy: propTypeEmptyString,
  copyColor: PropTypes.oneOf(validColors),
  fontWeight: PropTypes.oneOf(['regular', 'medium', 'semibold']),
  headingColor: PropTypes.oneOf(validColors),
  icon: PropTypes.func,
  maxImageWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  src: PropTypes.string,
  tag: PropTypes.oneOf(['div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  title: propTypeEmptyString,
};

Feature.defaultProps = {
  align: 'center',
  alignM: 'left',
  backgroundColor: 'marvel',
  copyColor: 'black',
  fontWeight: 'regular',
  headingColor: 'black',
  maxWidth: 360,
  tag: 'h4',
};



// WEBPACK FOOTER //
// ./src/components/modules/Feature/index.js